import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { AIMedia, UploadTypes } from '../../@types';

type Payload = {
  aiMediaId: string;
};

const deleteAiMedia = async (payload: Payload): Promise<AIMedia> => {
  const res = await axiosInstance.delete('/api/stock-gallery/delete-ai-media', { data: payload });
  return res.data;
};

export const useDeleteAiMedia = () => {
  return useMutation(deleteAiMedia, { onSuccess: (data) => data });
};
